import { render, staticRenderFns } from "./SpreadSheetIcon.vue?vue&type=template&id=56179802"
import script from "./SpreadSheetIcon.vue?vue&type=script&lang=js"
export * from "./SpreadSheetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports